import { render, staticRenderFns } from "./PromoTwo.vue?vue&type=template&id=3e1fe4cc&"
import script from "./PromoTwo.vue?vue&type=script&lang=js&"
export * from "./PromoTwo.vue?vue&type=script&lang=js&"
import style0 from "./PromoTwo.vue?vue&type=style&index=0&id=3e1fe4cc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports